var meta = { showLeftMenu: true, headIndex: 3, keepAlive: true };
export var router = [{
    path: '/dmp',
    meta: { showLeftMenu: false, headIndex: 3, keepAlive: true, changed: false, isBack: false },
    name: 'dmp',
    component: resolve => require(["./dmp.vue"], resolve),
}
]



// WEBPACK FOOTER //
// ./src/views/dmp/router.js